<template>
  <Upload ref="upload" :action="picurl" :multiple="multiple" :max-size="maxSize" type="drag"
          :format="format" :accept="accept" :on-success="handleSuccess" :on-format-error="handleFormatError"
          :data="{0:this.$cryptohttp.set(filedata)[0]}"
          :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload" :on-error="handleError"
          :on-remove="handeleRemove" :default-file-list="lists">
<!--:on-preview="handelePreview" -->
    <div style="padding: 5px 0">
      <Icon v-if="!$slots.content" type="ios-cloud-upload" size="40" style="color: #3399ff"></Icon>
      <p v-if="!$slots.content">{{ $t('m.uplad_files') }}</p>
      <slot name="content"></slot>
    </div>
  </Upload>
</template>

<script>
export default {
  name: 'upload-music',
  props: {
    lists: Array,
    multiple: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: null
    },
    format: Array,
    accept: {
      type: String,
      default: ''
    },
    //model:'',//模块 book_afterRead读后感  book书籍图片
    //filetype:'',//images（图片）、video（视频）、audio（音频）、file（文件）
    filedata: {
      type: [Boolean, Object],
      default: false
    },
    isExpert: {//名人数据库上传true 书籍上传false
      type: [Boolean, Object],
      default: false
    }
  },

  data() {
    return {
      picurl: 'https://culture.aqitai.com/api/user/v3/upload/uploadoss',
    }
  },

  methods: {

    /*****************************************************************
     *
     * 上传文件之前的钩子，参数为上传的文件，若返回 false 或者 Promise 则停止上传
     *
     *****************************************************************/
    handleBeforeUpload(data) {
      const check = this.multiple || this.$refs.upload.fileList.length < 1;
      if (!check) {
        this.$Notice.warning({
          title: '只能上传一个文件'
        });
      }
      return check;
      // console.log(data, '上传文件之前的钩子')
    },

    /*****************************************************************
     *
     * 文件格式验证失败时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handleFormatError(file, fileList) {
      let size = (file.size / 1024 / 1024).toFixed(2)
      this.$Notice.warning({
        title: '文件格式不正确',
        desc: `
                    文件名：${file.name} <br>
                    文件类型：${file.type} <br>
                    文件大小：${size}M
                `,
        duration: 5
      });
    },

    /*****************************************************************
     *
     * 文件超出指定大小限制时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handleMaxSize(file, fileList) {
      let size = (file.size / 1024 / 1024).toFixed(2)
      this.$Notice.warning({
        title: '文件超出指定大小限制',
        desc: `
                    文件名：${file.name} <br>
                    文件类型：${file.type} <br>
                    文件大小：${size}M
                `,
        duration: 5
      });
    },

    /*****************************************************************
     *
     * 点击已上传的文件链接时的钩子，返回字段为 file， 可以通过 file.response 拿到服务端返回数据
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handelePreview(file) {
      // console.log(file, '点击已上传的文件链接时的钩子')
      let url = file.response ? file.response.data.file_url : file.url
      window.open(url)
    },

    /*****************************************************************
     *
     * 文件上传成功时的钩子，返回字段为 response, file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     * @param   {response}         单图
     *
     *****************************************************************/
    handleSuccess(response, file, fileList) {
      // console.log(1,response)
      // console.log(2, file,)
      // console.log(3, fileList)
      this.$Notice.success({title: '上传成功'})
      var arr = fileList.filter(el => {
        if (el.response) return el
      })
      this.$emit('on-upload', arr)
    },

    /*****************************************************************
     *
     * 文件上传失败时的钩子，返回字段为 error, file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     * @param   {error}            单图
     *
     *****************************************************************/
    handleError(error, file, fileList) {
      // console.log(error, file, fileList, '文件上传失败时的钩子')
      this.$Notice.error({title: '上传失败，请检查网路'})
    },

    /*****************************************************************
     *
     * 文件列表移除文件时的钩子，返回字段为 file, fileList
     * @param   {file}             单图
     * @param   {fileList}         单图
     *
     *****************************************************************/
    handeleRemove(file, fileList) {
      console.log(file, fileList, '文件列表移除文件时的钩子')
      // if (file.used) this.delData(file, fileList)

      // let arr = fileList.filter(el => {
      //   if (el.response) el
      // })
      this.$emit('on-remove', fileList)
      // this.$emit('on-remove', fileList)//在开发视频分类上传附件时出现了问题，如果其它地方不好使了，修改这块兼容

    },

    /************************************************************
     *
     * 删除文件
     *
     ************************************************************/
    async delData(data, fileList) {
      let that = this
      let params = {}
      if (data.delurl) {
        params.url = data.delurl
      } else {
        params.url = `api/admin/v1/culture/moredel/${data.value}/${data.used}`
      }
      try {
        const res = await that.$https.delete(params)
        that.$Message.success('文件已删除')
        // console.log(res, '文件已删除')
      } catch (error) {
        that.$Message.warning('未能删除文件')
      }
    }
  },
  mounted() {

  }
}
</script>
